import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WpayMultiSelectAutoCompleteComponent } from "./wpay-multi-select-auto-complete.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from "@angular/material/legacy-autocomplete";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { SharedModule } from "@shared/shared.module";
import { MatDividerModule } from "@angular/material/divider";

@NgModule({
	declarations: [WpayMultiSelectAutoCompleteComponent],
	exports: [WpayMultiSelectAutoCompleteComponent],
	imports: [
		CommonModule,
		MatFormFieldModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
		MatInputModule,
		MatIconModule,
		MatAutocompleteModule,
		MatCheckboxModule,
		SharedModule,
		MatDividerModule
	]
})
export class WpayMultiSelectAutoCompleteModule {}
